import React from 'react';

const AuthzSubjectPermissionGroupFormModal = React.lazy(() => import('../components/FormModal'));
const authzSubjectPermissionGroupModalRegistry = {
    core_authzSubjectPermissionGroupId: AuthzSubjectPermissionGroupFormModal
};
export default authzSubjectPermissionGroupModalRegistry;
